enum MessageTypes {
    HeightChange = "heightChange",
    ScrollTo = "scrollTo",
    AfiliadoSignIn = "afiliadoSignIn",
    NoAfiliadoSignIn = "noAfiliadoSignIn",
    Redirect = "redirect",
    RouteChange= "routeChange",
    Ping= "ping",
    ClearUserHeader = "clearUserHeader",
    BlockUserLinks = "blockUserLinks",
    LogOut = "logOut",
    CentralizeIframe = "centralizeIframe",
    OpenTab = "openTab",
    QueueRedirectAfterSurvey = "queueRedirectAfterSurvey",
    CancelRedirectAfterSurvey = "cancelRedirectAfterSurvey",
    ResizeIframeAfterFewSeconds = "resizeIframeAfterFewSeconds"
}

class InterPagesMessages {
    constructor(
        public messageType: MessageTypes,
        public messageValue: string,
    ){}
}

class IframeCommunicatorService {
    public postMessageToParent(message: InterPagesMessages) {
        if ((window.parent as any).onMessageFromChildren) {
            (window.parent as any).onMessageFromChildren(message);
        }
    }
}

export default IframeCommunicatorService;
export { InterPagesMessages, MessageTypes };